import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AdCaller from 'helpers/ads/adCaller';
import JarvisAdUnit from 'helpers/ads/JarvisAdUnit';
import { InnovFallback } from 'helpers/ads/constants';
import pushNotification from 'helpers/pushnotification/pushnotification';
import ImageV2 from 'components_v2/common/ImageV2';
import { popupManager } from 'utils/popupManager';
import _get from 'lodash.get';
import { appendScriptToHead } from 'utils/DOMUtils';
import { loadAllAdsFromQueue, loadAdsCampaignStatus } from 'helpers/ads/redux';
import WithAdBlockerDetector from 'components_v2/common/AdBlockerDetector/WithAdBlockerDetector';
//import StickyDiv from 'components/StickyDiv';
//import { isTablet, isIE11 } from 'utils/common';
import WithMiniTv from 'modules/WithMiniTv/WithMiniTv';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen';
import PrimePaymentFlowCaller from 'components/PrimePaymentFlow/PrimePaymentFlowCaller';
import AlreadyPrimeToastLoader from 'components/PrimeMessages/AlreadyPrimeToastLoader';
import PrimeWelcomePopupLoader from 'components/PrimeWelcomePopup/PrimeWelcomePopupLoader';
import ToiSubscriptionFlowCaller from 'components/ToiSubscription/ToiSubscriptionFlowCaller';
import WithCubeAd from 'modules/WithCubeAd/WithCubeAd';
// import ConsentForm from 'components/Login/ConsentForm';
import AdCube from 'components_v2/common/AdCube';
import WithWebViewLoginHook from 'components_v2/common/WebViewLoginHook/WithWebViewLoginHook';
import miniTvStyle from 'components/MiniTvV2/UsPageMiniTvTheme.scss';
import OpenInAppBottomWidget from 'components_v2/common/OpenInAppBottomWidget/OpenInAppBottomWidget';
import { initiateLocateService, getIbeatContentType } from 'utils/common';
import { setIbeattrack } from 'utils/iBeatConfig';
import { GEOAPI_URL, IMAGE_URL } from '../../../constants';
// eslint-disable-next-line no-unused-vars
import s from './Layout.scss';
import ETHeader from '../EtimesHeader';
import ETFooter from '../EtimesFooter';
import { loadGdprData } from '../../../reduxUtils/modules/gdpr';
import {
  loadGeoData,
  loadGeoLocationData,
} from '../../../reduxUtils/modules/geo';
import RenderAds from '../../../routes/home/components/desktop/RenderAds/RenderAds';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.analticsScriptLoaded = false;
  }

  componentDidMount() {
    const { isWapView } = this.props;
    if (typeof window.geoinfo === 'object') {
      initiateLocateService(() => {
        this.props.loadGeoData(window.geoinfo);
        this.props.loadGeoLocationData(isWapView);
      });
    } else {
      initiateLocateService(() => {
        appendScriptToHead({
          scriptUrl: GEOAPI_URL,
          callback: this.props.loadGeoLocationData,
        });
      });
    }
    // this.props.loadGeoLocationData(isWapView);
    this.props.loadGdprData();
    this.loadAnalyticsScript();
    this.props.loadAllAdsFromQueue('', '');
    popupManager(undefined, false, this.props.popGeoConfig.web);
    pushNotification.init({ isCoachMark: true });
    if (this.props.adsCampaignStatusUrl) {
      this.props.loadAdsCampaignStatus(this.props.adsCampaignStatusUrl);
    }

    setIbeattrack({
      contentType: getIbeatContentType(
        this.props?.pageType,
        this.props?.isphotostory,
      ),
    });
    // initiateLocateService();
  }

  componentDidUpdate() {
    this.loadAnalyticsScript();
  }

  loadAnalyticsScript() {
    if (!this.analticsScriptLoaded) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (
          !dataObj.isEUuser ||
          (dataObj.isEUuser && dataObj.didUserOptOut === false) ||
          dataObj.userRegion === 'CA'
        ) {
          const script = document.createElement('script');
          script.setAttribute(
            'src',
            'https://static.clmbtech.com/ase/2658/3/aa.js',
          );
          script.setAttribute('async', 'async');
          document.body.appendChild(script);
          this.analticsScriptLoaded = true;
        }
      });
    }
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const {
      query,
      params,
      SidebarComponent,
      hideCyclicNav,
      l2navigationChild,
      desktopAdCode,
      deskopTopBannerData,
      headerData,
      layoutClass,
      commonData,
      showWeatherInC,
      enablePrimeFlow,
      isPrime,
      hideAds,
      skipAds,
      showTopSearchAtTop,
      userPrcData,
      gutterAdCode,
      bannerMsid,
      isFeatureShow=false,
    } = this.props;
    const { isWapView } = params;
    const frmapp = query.frmapp === 'yes' || query.frmapp === 'shorts';
    const viewClass = frmapp ? 'appView' : 'nonAppView';
    let headerAdCode;
    if (desktopAdCode && desktopAdCode.adCode) {
      headerAdCode = desktopAdCode;
    } else if (deskopTopBannerData && deskopTopBannerData.adCode) {
      headerAdCode = deskopTopBannerData;
    } else if (commonData && commonData.ROS) {
      headerAdCode = commonData.ROS;
    }
    let gutterAdData;
    if (gutterAdCode && gutterAdCode.adCode) {
      gutterAdData = gutterAdCode;
    } else if (commonData && commonData.gutterAd) {
      gutterAdData = commonData.gutterAd;
    }
    const childComponents =
      showTopSearchAtTop &&
      this.props.children[this.props.children.length - 1].props.id.includes(
        'topSearch',
      )
        ? [...this.props.children].slice(0, -1)
        : this.props.children;

    return (
      <div className={`${viewClass} ${layoutClass}`}>
        {showTopSearchAtTop
          ? this.props.children[this.props.children.length - 1]
          : ''}
        {!this.props.isPrime &&
          !this.props.params.hideMobileTopBar &&
          !this.props.hideAdCude &&
          !frmapp && <AdCube isWapView={isWapView} channel="etimes" />}
        {!this.props.isPrime &&
          !hideAds &&
          !skipAds && <JarvisAdUnit type="topBand" isWapView={isWapView} />}
        <div>
          {!this.props.isPrime &&
          !hideAds &&
          headerAdCode &&
          headerAdCode.adCode &&
          typeof headerData === 'object' ? (
            <RenderAds
              adObject={{
                name: 'masthead',
                ...headerAdCode,
              }}
              noPlaceholder
              adWapperClass={`${s.mastHeadAdWrapper} ${s.atfStickyTillHeader}`}
              adWrapperClass={`desktop_paisa ${s.adstickytillmaxwidth}`}
              colorTheme={headerData.colorTheme}
            />
          ) : null}
          {!frmapp && (
            <>
              <ETHeader
                isWapView={isWapView}
                isPrime={isPrime}
                hideCyclicNav={hideCyclicNav}
                l2navigationChild={l2navigationChild}
                headerData={headerData}
                hideTimesPointPopup={this.props.hideTimesPointPopup}
                showWeatherInC={showWeatherInC}
                enablePrimeFlow={enablePrimeFlow}
                pageType={this.props.pageType}
                geolocation={this.props.geolocation}
                msid={this.props.msid}
                // showPersonaliseForToi prop is for TOI/ETIMES AS
                showPersonaliseForToi={this.props.pageType === 'ARTICLESHOW'}
                isListingEtimesHomePage={this.props.isListingEtimesHomePage}
                pathname={this.props.pathname}
              />
            </>
          )}

          {this.props.pageType === 'Home' && (
            <PrimeScreen
              componentName="TopBand"
              theme="white_theme"
              isWapView={isWapView}
            />
          )}
        </div>
        <div
          className={`contentwrapper clearfix ${this.props.layoutType || ' '} ${
            this.props.customclasslayoutwrapper
              ? this.props.customclasslayoutwrapper
              : ''
          }`}
        >
          <div className="popupWrapper" />
          {this.props.showMiniTv &&
            !frmapp && (
              <WithMiniTv
                isWapView={false}
                styleObject={miniTvStyle}
                showMiniTvSection={this.props.showMiniTvSection}
                miniTvV2={this.props.miniTvV2}
                overRideClass={this.props.overRideClass}
              />
            )}
          {bannerMsid && (
            <div
              className={s.pageLogos}
              data-translate-id="cw"
              data-translate-page="1"
            >
              <ImageV2 src={`${IMAGE_URL}${bannerMsid}.cms`} />
            </div>
          )}
          {showTopSearchAtTop ? childComponents : this.props.children}
          {!this.props.isPrime && (
            <WithCubeAd pageType={this.props.pageType} isWapView={isWapView} />
          )}
          {!frmapp &&
            !isWapView &&
            typeof SidebarComponent === 'function' &&
            SidebarComponent.prototype.isReactComponent &&
            this.props.sidebarData && (
              <SidebarComponent data={this.props.sidebarData} />
            )}
          {(!hideAds && this.props?.headerData?.sitesync) ||
          this.props?.common?.sitesync ? (
            <AdCaller
              skipReRender
              data={{
                ...this.props.headerData.sitesync,
                ...this.props?.common?.sitesync,
              }}
              immediateLoad
            />
          ) : null}
        </div>
        {!this.props.isPrime &&
          !hideAds &&
          !skipAds &&
          this.props.endOfPageAD && (
            <div data-translate-id="cw" key="ad_endofarticle">
              <AdCaller
                adWapperClass="ad_spacing contentwrapper"
                skipReRender
                data={{ ...this.props.endOfPageAD, name: 'taboola_bottom' }}
              />
            </div>
          )}
        {!frmapp &&
          !params.hideMobileTopBar &&
          !this.props.skipFooter && (
            <>
              <ETFooter
                footerData={this.props.footerData}
                isPrivateUser={this.props.isPrivateUser}
                isFeatureShow={isFeatureShow}
              />
            </>
          )}
        {/* {commonData &&
          commonData.geoAd && (
            <AdCaller
              immediateLoad
              data={commonData.geoAd}
              deviceType="all"
              cookieKey="geolocation"
            />
          )}
        {commonData &&
          commonData.geoState && (
            <AdCaller
              immediateLoad
              data={commonData.geoState}
              deviceType="all"
              cookieKey="geostate"
            />
          )} */}
        <WithWebViewLoginHook frmapp={frmapp} />
        <OpenInAppBottomWidget condition={false} />
        <PrimePaymentFlowCaller />
        {userPrcData &&
          !userPrcData?.gstAddressUpdateRequired && (
            <>
              <PrimeWelcomePopupLoader
                isWapView={isWapView}
                userPrcData={userPrcData}
              />
              <AlreadyPrimeToastLoader
                userData={this.props.userData}
                userPrcData={userPrcData}
              />
            </>
          )}

        <ToiSubscriptionFlowCaller
          userData={this.props.userData}
          isWapView={isWapView}
          userPrcData={userPrcData}
        />
        {/* {!this.props.consentGiven && (
          <ConsentForm isPrivateUser={this.props.isPrivateUser} overlayView />
        )} */}
        {!this.props.hideAdBlockerDetector &&
          !(
            this.props.hideAdBlockerConfig &&
            this.props.hideAdBlockerConfig === '1'
          ) &&
          !this.props.isPrime && <WithAdBlockerDetector />}
        {!hideAds &&
          !this.props.hideGutterAd &&
          gutterAdData && (
            <RenderAds
              noPlaceholder
              adObject={{
                adType: 'dfp',
                ...gutterAdData,
                name: 'gutter',
                failover: InnovFallback,
                perpetualRefresh: 1,
              }}
            />
          )}
        <div className="popupWrapper" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  sidebarData: state.sidebar ? state.sidebar.data : {},
  headerData: state.header.data,
  //footer: state.footer,
  isPrivateUser: state.gdpr.isPrivateUser,
  // adsQueueData: state.adCaller.adsQueueData,
  // consentGiven: !(
  //   state.login.userData && state.login.userData.showConsentPopUp
  // ),
  userData: _get(state, 'login.userData', {}),
  currentCountry: _get(state, 'geo.currentCountry', undefined),
  navigationData: state.header.data,
  footerData: state.footer_v2.data,
  commonData: state.commonData.data,
  adsCampaignStatus: state.adCaller.adsCampaignStatus,
  popGeoConfig: _get(state, 'common.siteConfig.popup', {
    web: {
      enabled: 0,
      geo: {
        IN: '1',
        US: '1',
        ROW: '1',
      },
    },
  }),
  userPrcData: state.login.userPrcData,
  hideAdBlockerConfig: _get(state, 'common.siteConfig.hideAdBlocker', '0'),
});

const mapDispatchToProps = dispatch => ({
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
  loadGdprData: params => {
    dispatch(loadGdprData(params));
  },
  loadGeoData: params => {
    dispatch(loadGeoData(params));
  },
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
  loadAdsCampaignStatus: url => {
    dispatch(loadAdsCampaignStatus(url));
  },
});

Layout.propTypes = {
  layoutClass: PropTypes.string,
  isPrime: PropTypes.bool.isRequired,
  pageType: PropTypes.string,
  SidebarComponent: PropTypes.shape({}),
  l2navigationChild: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  headerData: PropTypes.shape({}).isRequired,
  sidebarData: PropTypes.arrayOf(PropTypes.shape({})),
  query: PropTypes.shape({}).isRequired,
  params: PropTypes.shape({
    fullPath: PropTypes.string.isRequired,
    hideMobileTopBar: PropTypes.bool,
    liveblogHeader: PropTypes.bool,
    refreshAtfAd: PropTypes.bool,
  }).isRequired,
  // consentGiven: PropTypes.bool,
  loadGdprData: PropTypes.func.isRequired,
  loadGeoData: PropTypes.func.isRequired,
  loadGeoLocationData: PropTypes.func.isRequired,
  loadAllAdsFromQueue: PropTypes.func.isRequired,
  layoutType: PropTypes.string,
  footerData: PropTypes.shape({}),
  desktopAdCode: PropTypes.shape({}),
  // subSecSeoLocation: PropTypes.string,
  isPrivateUser: PropTypes.bool,
  //currentCountry: PropTypes.string,
  commonData: PropTypes.shape({ gutterAd: PropTypes.shape({}) }),
  hideAdBlockerDetector: PropTypes.bool,
  hideCyclicNav: PropTypes.bool,
  hideGutterAd: PropTypes.bool,
  hideTimesPointPopup: PropTypes.bool,
  showMiniTv: PropTypes.bool,
  showMiniTvSection: PropTypes.string,
  showWeatherInC: PropTypes.bool,
  enablePrimeFlow: PropTypes.bool,
  miniTvV2: PropTypes.bool,
  userData: PropTypes.shape({
    showConsentPopUp: PropTypes.bool,
  }),
  hideAdCude: PropTypes.bool,
  customclasslayoutwrapper: PropTypes.string,
  hideAds: PropTypes.bool,
  geolocation: PropTypes.string,
  adsCampaignStatusUrl: PropTypes.string,
  loadAdsCampaignStatus: PropTypes.func.isRequired,
  adsCampaignStatus: PropTypes.shape({}),
  skipAds: PropTypes.bool,
  showTopSearchAtTop: PropTypes.bool,
  hideAdBlockerConfig: PropTypes.string,
  msid: PropTypes.string,
  bannerMsid: PropTypes.string,
  endOfPageAD: PropTypes.shape({}),
};

Layout.defaultProps = {
  layoutClass: '',
  pageType: '',
  SidebarComponent: undefined,
  l2navigationChild: undefined,
  // consentGiven: true,
  sidebarData: [],
  layoutType: '',
  //adTheme: '',
  //hideStickyBackToTop: false,
  //mobileAdCode: undefined,
  desktopAdCode: undefined,
  //adsCampaignStatus: undefined,
  adsCampaignStatusUrl: undefined,
  //hideBreadcrumAtBottom: false,
  showMiniTv: false,
  //deskopTopBannerData: undefined,
  //refreshFBNAd: false,
  hideAdBlockerDetector: false,
  hideCyclicNav: false,
  //pageType: '',
  // subSecSeoLocation: '',
  isPrivateUser: true,
  //currentCountry: undefined,
  //navigationData: undefined,
  footerData: undefined,
  commonData: {},
  hideGutterAd: false,
  hideTimesPointPopup: false,
  showMiniTvSection: '',
  showWeatherInC: false,
  enablePrimeFlow: false,
  miniTvV2: false,
  userData: undefined,
  hideAdCude: false,
  customclasslayoutwrapper: '',
  hideAds: false,
  geolocation: '1',
  adsCampaignStatus: undefined,
  skipAds: false,
  showTopSearchAtTop: false,
  hideAdBlockerConfig: '0',
  msid: '',
  bannerMsid: '',
  endOfPageAD: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
